export default "__VITE_ASSET__C5yV$$wR__"